import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  Reference,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { isDefined } from '@freelancer/utils';
import { UserEmailRequestStatusAjax } from './user-email-request.backend-model';
import { transformUserEmailRequest } from './user-email-request.transformer';
import { UserEmailRequestCollection } from './user-email-request.types';

const USER_EMAIL_REQUEST_TYPE = 'userEmailRequest';

export function userEmailRequestReducer(
  state: CollectionStateSlice<UserEmailRequestCollection> = {},
  action: CollectionActions<UserEmailRequestCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === USER_EMAIL_REQUEST_TYPE) {
        const { result, ref, order } = action.payload;

        return mergeDocuments<UserEmailRequestCollection>(
          state,
          transformIntoDocuments(
            result.email_requests,
            transformUserEmailRequest,
          ),
          order,
          ref,
        );
      }

      return state;
    }

    case 'API_DELETE': {
      if (action.payload.type === USER_EMAIL_REQUEST_TYPE) {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById(ref, state, originalDocument.id);
      }

      return state;
    }

    case 'API_DELETE_ERROR': {
      if (action.payload.type === USER_EMAIL_REQUEST_TYPE) {
        const { originalDocument, ref } = action.payload;
        return mergeWebsocketDocuments<UserEmailRequestCollection>(
          state,
          transformIntoDocuments([originalDocument], o => o),
          ref,
        );
      }

      return state;
    }

    case 'WS_MESSAGE': {
      if (action.payload.type === 'emailChange') {
        const { data, toUserId } = action.payload;
        const ref: Reference<UserEmailRequestCollection> = {
          path: {
            collection: USER_EMAIL_REQUEST_TYPE,
            authUid: toUserId,
          },
        };

        if (!isDefined(data.ipAddress)) {
          throw new ReferenceError('Missing IP address field.');
        }

        return mergeWebsocketDocuments<UserEmailRequestCollection>(
          state,
          transformIntoDocuments(
            [
              {
                id: data.requestId,
                email: data.new_email,
                ip_address: data.ipAddress,
                status: UserEmailRequestStatusAjax.PENDING,
              },
            ],
            transformUserEmailRequest,
          ),
          ref,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
